import React, { useEffect, useState } from "react";
import {
  customerListId,
  addToCard,
  addProductToList,
} from "../../../server/ShoppingList";
import { useParams } from "react-router-dom";
import showAlert from "../../../server/ShowAlert";
import { getCart } from "../../../server/CollectSite";
import { setPreload } from "../../../server/CartsOpen";
import { useDispatch, useSelector } from "react-redux";
import { handleCartResponse } from "./UserShoppingList";
const UserShoppingListProduct = ({ setProductPopUp, setSelectedProd }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const stationId = useSelector((state) => state.user.stationId);
  const [products, setProducts] = useState(null);
  const [listName, setListName] = useState("טוען רשימה...");
  const [listId, setListId] = useState("");

  useEffect(() => {
    console.log("!! id", id);
    console.log("!! listId", listId);

    getProductList();
  }, []);
  const getProductList = () => {
    console.log("id on customerListId", id);
    customerListId(id, stationId)
      .then((x) => {
        if (x.data) {
          setListId(x.data.id);
          setListName(x.data.name);
          setProducts(x.data.items ?? []);
          console.log("customerList", x.data);
        }
      })
      .catch((e) => {
        if (e.response.status === 404) {
          setListName("הרשימה לא נמצאה");
          showAlert({ msgTitle: "הרשימה לא נמצאה", msgType: "error" });
        }
        console.log(e);
      });
  };
  const AddToCard = () => {
    if (!products || products.length === 0) {
      showAlert({
        msgTitle: "אין מוצרים ברשימה",
        msgType: "error",
      });
      return;
    }

    addToCard(stationId, products)
      .then((x) => {
        if (!x.data) {
          showAlert({
            msgTitle: "הייתה בעיה בהוספת הרשימה לעגלת קניות",
            msgType: "error",
          });
          return;
        }
        const reservedItems = x.data?.reservedItems || [];
        handleCartResponse(
          reservedItems,
          products,
          dispatch,
          stationId,
          showAlert,
          getCart,
          x.data?.allFailed
        );
      })
      .catch((e) => {
        console.error(e);
        showAlert({ msgTitle: "המוצרים אינם זמינים במלאי", msgType: "error" });
      });
  };
  const SetQuantity = (value, id) => {
    const product = [...products];
    const qty = Math.max(1, parseInt(value) || 1);
    const item = product.find((item) => item.productId === id);
    if (item) item.quantity = qty;
    setProducts(product);
  };

  const AddToShopList = (quantity, productId) => {
    dispatch(setPreload(true));

    addProductToList(listId, productId, quantity)
      .then((response) => {
        if (!response.data) {
          showAlert({ msgTitle: "הייתה בעיה בעדכון הרשימה", msgType: "error" });
          return;
        }

        if (response.data.status === "DELETED") {
          setProducts(products.filter((item) => item.productId !== productId));
          showAlert({ msgTitle: "המוצר נמחק מהרשימה", msgType: "error" });
        } else if (response.data.status === "UPDATED") {
          const updatedProducts = products.map((item) =>
            item.productId === productId ? { ...item, quantity } : item
          );
          setProducts(updatedProducts);
          showAlert({ msgTitle: "הכמות השתנה", msgType: "success" });
        }
      })
      .catch(() => {
        showAlert({ msgTitle: "שגיאה בשרת, נסה שנית", msgType: "error" });
      })
      .finally(() => dispatch(setPreload(false)));
  };

  const openProduct = (prod) => {
    console.log("prod", prod);
    setSelectedProd(prod.product);
    setProductPopUp(true);
  };
  const handleQuantityChange = (value, productId) => {
    const qty = Math.max(1, parseInt(value) || 1);
    const updatedProducts = products.map((p) =>
      p.productId === productId ? { ...p, quantity: qty } : p
    );
    setProducts(updatedProducts);
  };

  const handleQuantityBlur = (productId, quantity) => {
    AddToShopList(quantity, productId);
  };

  return (
    <div className="shopping-list-product">
      {listName ? (
        <div>
          <h1>{listName}</h1>
          {products?.length > 0 ? (
            <div>
              <table>
                <tbody>
                  <tr>
                    <th>שם המוצר</th>
                    <th>כמות</th>
                    <th></th>
                  </tr>
                  {products.map((prod) => (
                    <tr key={prod.productId} className="shopping-list-row">
                      <td>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => openProduct(prod)}
                        >
                          {prod.product ? prod.product.name : prod.productId}
                        </a>
                      </td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          value={prod.quantity}
                          onChange={(e) =>
                            handleQuantityChange(e.target.value, prod.productId)
                          }
                          onBlur={(e) =>
                            handleQuantityBlur(
                              prod.productId,
                              Math.max(1, parseInt(e.target.value) || 1)
                            )
                          }
                        />
                      </td>
                      <td>
                        <button
                          className="btn"
                          onClick={() => AddToShopList(0, prod.productId)}
                        >
                          מחק מוצר
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div>
                <button className="btn" onClick={AddToCard}>
                  הוספה לסל קניות
                </button>
              </div>
            </div>
          ) : (
            products && <h2>אין פריטים ברשימה</h2>
          )}
        </div>
      ) : (
        <h1>אין רשימה להצגה</h1>
      )}
    </div>
  );
};

export default UserShoppingListProduct;
